module.exports = __webpack_public_path__ + "static/media/cq_allega_documento b.e77151dd.svg";